module.exports = __webpack_public_path__ + "3822981aa95136f253b9ab1bbbea532c.png";